export const hideScroll = () => {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) {
        document.body.style.setProperty('padding-right', `${scrollbarWidth}px`, 'important');
    }
};
export const resetScroll = () => {
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
};
